import { axios } from '$app-web/api/axios';

import { Endpoints } from '../constant';

export interface AuditEvent {
    event_id: string | number;
    study_id: number;
    actor?: 'app' | 'device' | null;
    record_time?: string | number | null;
    entity_ids?: Array<string | number>;
    payload?: Record<string, unknown>;
}

export async function sendAuditEvents(events: Array<AuditEvent>): Promise<void> {
    try {
        await axios.post(Endpoints.AuditTrailEvent, events);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to send audit trail event:', error);
    }
}
